<template>
  <b-navbar toggleable="lg" type="dark" variant="home-primary">
    <div class="navbar-brand-links">
      <a href="https://www.byu.edu/" target="_blank">
        <img
          class="brand-image"
          :src="`${baseURL}/storage/media/welcome/byu-logo-white-small.svg`"
        />
      </a>
      <div class="divider">&nbsp;</div>
      <router-link :to="{ name: 'home' }" class="pcs-navbar-brand">
        PCS
      </router-link>
    </div>

    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav class="ml-auto">
        <b-nav-item :to="{ name: 'library' }" link-classes="links" active-class='active-style'>
          Library
        </b-nav-item>

        <b-nav-item :to="{ name: 'about' }" link-classes="links" active-class='active-style'>
          About
        </b-nav-item>
        <!-- Teacher page link -->
        <b-nav-item
          v-if="authenticated && user.teacher"
          :to="{ name: 'teacher' }"
          link-classes="links"
          active-class='active-style'
        >
          Class Data
        </b-nav-item>
        <!-- Admin and PCS Manager settings page link -->
        <b-nav-item
          v-if="authenticated && (user.admin || user.manages)"
          :to="{ name: 'admin' }"
          link-classes="links"
          active-class='active-style'
        >
          {{ user.admin ? 'Admin Settings' : 'PCS Manager Settings' }}
        </b-nav-item>

        <b-nav-text v-if="!authenticated">
          <div class="nav-links-divider">|</div>
        </b-nav-text>

        <b-nav-item
          v-if="!authenticated"
          :to="{ name: 'login' }"
          link-classes="links"
          active-class='active-style'
        >
          {{ $t('login') }}
        </b-nav-item>
        <b-nav-item
          v-if="!authenticated"
          :to="{ name: 'register' }"
          link-classes="links"
          active-class='active-style'
        >
          {{ $t('register') }}
        </b-nav-item>

        <b-nav-item-dropdown toggle-class="links" v-if="authenticated" right>
          <template #button-content>
            <img
              :src="user.photo_url"
              class="rounded-circle profile-photo mr-1"
            />
            {{ user.name }}
          </template>
          <b-dropdown-item
            link-class="text-home-primary"
            :to="{ name: 'settings' }"
          >
            <fa icon="cog" fixed-width />
            {{ $t('settings') }}
          </b-dropdown-item>
          <b-dropdown-item
            link-class="text-home-primary"
            href="#"
            @click.prevent="logout"
          >
            <fa icon="sign-out-alt" fixed-width />
            {{ $t('logout') }}
          </b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import LocaleDropdown from './LocaleDropdown'

export default {
  components: {
    LocaleDropdown,
  },

  data: () => ({
    appName: window.config.appName,
    pcs: '',
    tabs: [],
  }),

  computed: {
    ...mapGetters({
      authenticated: 'auth/check',
      user: 'auth/user',
    }),
    baseURL: function () {
      return process.env.MIX_BASE_URL
    },
  },

  methods: {
    ...mapActions({
      _logout: 'auth/logout',
    }),
    async logout() {
      // Log out the user.
      await this._logout()

      // Redirect to login.
      this.$router.push({ name: 'home' })
    },
  },
}
</script>

<style lang="scss" scoped>
.navbar-brand-links {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-right: auto;
  font-weight: normal;
}

.divider {
  background: #0057b8;
  width: 1px;
  height: 50px;
}

.pcs-navbar-brand {
  font-size: 1.75rem;
  text-decoration: none;
  color: white !important;
  &:hover {
    text-decoration: none;
    color: white !important;
  }
}

.d-inline-block > li {
  display: inline-block;
}

.profile-photo {
  width: 2rem;
  height: 2rem;
  margin: -0.375rem 0;
}

.nav-links-divider {
  font-size: 20px;
  font-weight: bold;
  color: white;
  padding-right: 18px;
  padding-left: 18px;
  padding-top: 5px;
  border: solid 3px var(--home-primary);
}

.brand-image {
  height: 20px;
  padding-left: 10px;
  padding-right: 5px;
}

#nav-collapse::v-deep {
  a.links {
    color: white !important;
    font-size: 12px;
    font-weight: 600;
    margin: 4px;
    padding-right: 4px;
    padding-left: 4px;
    letter-spacing: 0.1rem;
    text-decoration: none !important;
    text-transform: uppercase;
    font-family: var(--byu-headline-font), Ringside Narrow SSm, Open Sans,
      Helvetica, Arial, sans-serif;
    border: solid 3px var(--home-primary);
  }
}

@media (max-width: 992px) {
  .nav-links-divider {
      display: none;
  }
  a.links{
    padding-left: 1em;
    font-size: 16px !important;
      &:active{
        background-color: #002850;
        border-radius: 22px;
      }
  }
  .active-style{
    border-width: 2px;
    border-color: white;
    background-color: #002850;
    border-radius: 22px;
    
  }
}

@media (min-width: 992px) {
  .nav-links-divider {
      display: block;
  }
  .active-style {
    border-color: var(--home-primary);
    border-bottom-color: white !important;
    border-width: 3px;
    border-style: solid;

  }
  a.links{
    &:hover {
      border-color: #002e5d;
      text-decoration: none ;
      color: white ;
      border-bottom-color: white !important;
      border-width: 3px;
      border-style: solid;
      background-color: var(--home-primary);
    }
  }
}

</style>
